<template>
  <div>
    <div class="text-xl font-bold text-text leading-tight mb-2">{{ $t('listTitle') }}</div>
    <draggable :value="listing" class="divide-y divide-border -mx-2 lg:-mx-6"
               tag="div"
               handle=".handle"
               :group="{ name: 'groups' }"
               @input="handleGroups">
      <div v-for="(el,i) in listing" :key="i" class="pt-8 mb-6">
        <div class="flex mb-4 group px-2 pr-4 lg:px-6"
             v-if="(expenses_by_groups.length > 1
                         || (expenses_by_groups.id === null && expenses_by_groups.length === 1))
                         && !(el.id === null && el.childs.length === 0)">
          <div class="text-text text-md mr-auto font-bold">{{ el.title }}</div>
          <template v-if="!currentUserIsWatcher">
            <div v-if="el.id!==null"
                 @click="$emit('editGroup',el)">
              <IconEdit class="opacity-0 group-hover:opacity-100
                               transition duration-200 cursor-pointer
                               text-icon hover:text-icon-hover mr-4"/>
            </div>
            <div class="control-icon handle lg:-mr-2" v-if="el.id !== null && listing.length > 2">
              <IconMove class="transition duration-200 cursor-pointer
                               text-icon hover:text-icon-hover"/>
            </div>
          </template>
        </div>

        <draggable
            :value="el.childs"
            handle=".handle"
            :group="{ name: 'items' }"
            @input="handleChild($event,el.id)">
          <div v-if="el.childs.length > 0"
               v-for="(item,j) in el.childs" :key="j"
               class="flex items-center rounded pl-4 lg:pl-11 pr-4 py-4
                        bg-block hover:bg-bg group
                        transition duration-200">
            <MKIcons :icon="item.icon" class="text-icon mr-6 w-10 h-10 -my-2 text-md"/>
            <div class="text-text-secondary text-sm mr-auto -ml-0-5">{{ item.title }}</div>
            <div class="mr-16 flex items-center space-x-4">
              <IconArrowDownSquare v-if="item.is_default"
                                   class="text-icon-info -my-2"
                                   v-tooltip="$t('tooltipIsDefault')"/>
            </div>
            <template v-if="!currentUserIsWatcher">
              <div class="mr-4" @click="$emit('edit',item)">
                <IconEdit class="opacity-0 group-hover:opacity-100
                                 transition duration-200 cursor-pointer
                                 text-icon hover:text-icon-hover"/>
              </div>
              <div class="handle">
                <IconMove class="transition duration-200 cursor-pointer text-icon hover:text-icon-hover"/>
              </div>
            </template>
          </div>
          <div slot="footer" v-if="el.childs.length === 0 && (el.id !== null || listing.length === 1) "
               class="text-md pl-6 text-text">
            {{ $t('emptyList') }}
          </div>
        </draggable>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import {mapActions, mapGetters, mapState} from "vuex";
import IconEdit from "@/components/icons/IconEdit";
import IconMove from "@/components/icons/IconMove";
import MKIcons from "@/components/icons/MKIcons/MKIcons";
import IconArrowDownSquare from "@/components/icons/IconArrowDownSquare";

export default {
  name: "ExpenseList",
  components: {IconArrowDownSquare, MKIcons, IconMove, IconEdit, draggable},
  data() {
    return {
      listing: []
    }
  },
  computed: {
    ...mapState('space/expenses', ['expenses', 'expense_groups']),
    ...mapGetters('space/expenses', ['expenses_by_groups']),
    ...mapGetters('space', ['currentUserIsWatcher']),
  },
  methods: {
    ...mapActions('space/expenses', ['updateExpensesOrder', 'updateExpensesGroupsOrder']),
    setListing() {
      this.listing = this.expenses_by_groups;
    },
    handleGroups(groups) {
      this.listing = groups.map((item, i) => ({...item, order: !!item.id ? i : 999}));
      //- sort null group as the last
      this.listing.sort((a, b) => a.order - b.order);

      this.updateExpensesGroupsOrder(this.listing);
    },
    handleChild(list, group_id) {
      //list - expenses in group, id - group id of list
      //apply changes in full list
      this.listing = this.listing.map(i => {
        if (i.id === group_id) {
          return {
            ...i,
            childs: list.map((j, o) => ({...j, group_id: group_id, order: o}))
          };
        } else {
          return i
        }
      });

      this.updateExpensesOrder({list, group_id})
    },
  },
  mounted() {
    this.setListing();
  },
  i18n: {
    messages: {
      en: {
        listTitle: 'Expense categories list',
        emptyList: 'No expenses in this group',
        tooltipIsDefault: 'Default expense category for imported transactions'
      },
      ru: {
        listTitle: 'Список категорий расходов',
        emptyList: 'В этой группе пока нет счетов',
        tooltipIsDefault: 'Категория расхода по умолчанию для импортируемых транзакций'
      }
    }
  }
}
</script>
